module.exports = __webpack_public_path__ + "static/media/img1-3.9ed31293.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/nutricheck_foliar/ZN/img1-3.png
// module id = 1959
// module chunks = 3